import { i18n } from '../../../../i18n/i18n';
import style from './TranslationFilter.less';
import * as React from 'react';

interface TranslationFilterProps extends React.ClassAttributes<any> {
    disabled?: boolean;
    filter: any[];
    label?: string;
    onChange: (data: string) => void;
    value: number | string;
    width?: number;
}

export class TranslationFilter extends React.Component<TranslationFilterProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.filter = props.filter || [];
        this.onChange = this.onChange.bind(this);
    }

    private filter: any[];

    componentDidMount(): void {
        this.init();
    }

    init(): void {
        const filterLength: number = this.filter.length;
        const value: number | string = this.props.value;

        if (
            (typeof value !== 'number' && typeof value !== 'string' && filterLength)
            || (this.filter.length === 1 && value !== this.filter[0].key)
        ) {
            this.onChange({ target: { value: this.filter[0].key } });
        }
    }

    onChange(event: any): void {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(((event || {}).target || {}).value);
        }
    }

    render(): JSX.Element {
        return (
            <div className={style.filter}>
                {this.props.label &&
                    <label
                        key='label-filter'
                        htmlFor='select-filter'
                    >
                        {this.props.label}
                    </label>
                }
                <select
                    key='select-filter'
                    id='select-filter'
                    value={this.props.value}
                    disabled={this.props.disabled || this.filter.length < 2}
                    onChange={this.onChange}
                >
                    {!this.filter.length &&
                        <option>{i18n('Nicht verfügbar', 'sys')}</option>
                    }
                    {this.filter.map((filter: any, index: number) =>
                        <option
                            key={`filter-${index}`}
                            value={filter.key}
                        >
                            {filter.name}
                        </option>
                    )}
                </select>
            </div>
        );
    }
}
